"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const AutomationColor = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#716BF1",
        d: "M6.108 5.185v13.63a.923.923 0 0 0 1.336.825l13.628-6.814a.923.923 0 0 0 0-1.652L7.444 4.36a.923.923 0 0 0-1.336.825Z"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#9C97F5",
        d: "M2.417 8.817v6.364a.923.923 0 0 0 1.306.84l7-3.181a.923.923 0 0 0 0-1.681l-7-3.182a.923.923 0 0 0-1.306.84Z"
      }
    )
  );
};
export default AutomationColor;
